var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRain(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "50px",
    height: "50px",
    viewBox: "388 229 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M430.8,244.4c0-0.3,0.1-0.7,0.1-1c0-5-4-9-9-9c-1.5,0-2.9,0.4-4.2,1.1c-2.1-3.1-5.6-4.9-9.4-4.9   c-6.3,0-11.5,5.1-11.5,11.5c0,0.6,0.1,1.3,0.2,1.9c-4.4,0.2-8,3.9-8,8.3c0,4.6,3.7,8.4,8.4,8.4h30.6c4.6,0,8.4-3.7,8.4-8.4   C436.3,248.7,434,245.6,430.8,244.4z M427.9,258h-30.6c-3.2,0-5.9-2.6-5.9-5.9s2.6-5.9,5.9-5.9h2.9l-0.5-1.6   c-0.3-0.9-0.4-1.8-0.4-2.7c0-4.9,4-9,9-9c3.3,0,6.4,1.8,7.9,4.8l0.7,1.3l1.2-0.9c1.1-0.9,2.5-1.3,3.9-1.3c3.6,0,6.5,2.9,6.5,6.5   c0,0.5-0.1,1-0.2,1.6l-0.3,1.3l1.3,0.3c2.7,0.6,4.6,3,4.6,5.7C433.8,255.4,431.1,258,427.9,258z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M399.1,262.6c-0.7,0-1.2,0.6-1.2,1.2v8c0,0.7,0.6,1.2,1.2,1.2c0.7,0,1.2-0.6,1.2-1.2v-8   C400.4,263.2,399.8,262.6,399.1,262.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M410.1,262.6c-0.7,0-1.2,0.6-1.2,1.2v8c0,0.7,0.6,1.2,1.2,1.2c0.7,0,1.2-0.6,1.2-1.2v-8   C411.3,263.2,410.8,262.6,410.1,262.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M415.6,262.6c-0.7,0-1.2,0.6-1.2,1.2v12.2c0,0.7,0.6,1.2,1.2,1.2c0.7,0,1.2-0.6,1.2-1.2v-12.2   C416.8,263.2,416.2,262.6,415.6,262.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M404.6,262.6c-0.7,0-1.2,0.6-1.2,1.2v12.2c0,0.7,0.6,1.2,1.2,1.2c0.7,0,1.2-0.6,1.2-1.2v-12.2   C405.8,263.2,405.3,262.6,404.6,262.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M421,262.6c-0.7,0-1.2,0.6-1.2,1.2v8c0,0.7,0.6,1.2,1.2,1.2s1.2-0.6,1.2-1.2v-8   C422.3,263.2,421.7,262.6,421,262.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M426.2,262.6c-0.7,0-1.2,0.6-1.2,1.2v4c0,0.7,0.6,1.2,1.2,1.2c0.7,0,1.2-0.6,1.2-1.2v-4   C427.4,263.2,426.9,262.6,426.2,262.6z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRain);
export default __webpack_public_path__ + "static/media/rain.105b8ded59fb769cc8a57c7e7fdbc9e9.svg";
export { ForwardRef as ReactComponent };